export enum Urls {
    DISTRIBUTOR = 'distributor',
    AGENT = 'agent',
    UNIT = 'unit',
    PRODUCT = 'product',
};

/**
 * Node Types
 */
export enum NodeTypes {
    ALERT = 'alert',
    AUDIO = 'audio',
    BLANK = 'blank',
    DATE = 'date',
    DRAWING = 'drawing',
    END = 'diagram-end',
    LIST = 'list',
    MATRIX = 'matrix',
    NOTIFICATION = 'notification',
    NUMBER = 'number',
    PICTURE = 'picture',
    PROCESS = 'process',
    QUESTION = 'question',
    START = 'diagram-begin',
    SUM = 'sum',
    TEXT = 'text',
    TIME = 'time',
    VIDEO = 'video'
};

export enum DiagramTypes {
    DIAGRAM = 'diagram',
    PALETTE = 'palette',
    WORKFLOW = 'workflow',
    TASKFLOW = 'taskflow'
};

export enum DiagramClasses {
    WORKFLOW_DIAGRAM = 'workflow-diagram',
    WOFKFLOW_PALETTE = 'workflow-palette',
    TASKFLOW_DIAGRAM = 'taskflow-diagram',
    TASKFLOW_PALETTE = 'taskflow-palette',
    DIAGRAM_CLASS = 'diagram',
    PALETTE_CLASS = 'palette',
    WORKFLOW_CONTAINER = 'workflow-container',
    TASKFLOW_CONTAINER = 'taskflow-container',
    TASKFLOW_MODAL_OPEN = 'taskflow-modal-open',
};

/**
 * Port types
 */
export enum PortTypes {
    TRUE = 'T',
    FALSE = 'F',
    DEFAULT = 'D',
    LEFT = 'L'
};

export enum ZoomThreshold {
    UPPER = 300,
    LOWER = 10,
    INCREMENT = 10
};

export enum WorkflowEventType {
    PROCESS = 1,
    NOTIFICATION = 2
};

export enum EndLinkTypes {
    END = 'end',
    CANCEL = 'cancel'
};

export enum Profile {
    UNIT = 1,
    DISTRIBUTOR = 2,
    AGENT = 3
};

export enum Events {
    WORKFLOW_EDIT_ICON_CLICKED = 'workflow-edit-icon-clicked',
    TASKFLOW_EDIT_ICON_CLICKED = 'taskflow-edit-icon-clicked',
    CANCEL_TASKFLOW_MODAL = 'cancel-taskflow-modal',
    SAVE_TASKFLOW = 'save-new-taskflow',
    UPDATE_TASKFLOW = 'update-existing-taskflow',
    SAVE_WORKFLOW = 'save-new-workflow',
    UPDATE_WORKFLOW = 'update-existing-workflow',
    NEW_WORKFLOW = 'new-workflow'
};

export enum Clients {
    DEV = 'dev'
};

export enum TypesValidation {
    INPUT = 'input',
    TEXAREA = 'textarea',
    DATE = 'date',
    NUMBER = 'number',
    IMAGE = 'image',
    CHECKBOX = 'checkbox',
    RADIO = 'radio',
    TREEVIEW = 'treeview',
    FILEUPLOAD = 'fileUpload',
};

export enum StatusProcess {
    ALL = 0,
    PENDENT = 1,
    IN_PROGRESS = 2,
    DONE = 3,
    ERROR = 4,
    OVERDUE = 5,
    WAIT = 6
}

export enum WidgetTypes {
    COUNTER = 1,
    LINE_CHART = 2,
    LIST = 3,
    GROUP = 4,
    RANGE_CHART = 5,
    GOALS = 6,
    TABLE = 7,
    BAR_CHART = 8
    GOALS_CHART = 9,
}

export enum FrequencyType {
    DAYS = 1,
    MONTHS = 2,
    YEARS = 3,
    HOUR = 4,
    MINUTES = 5
 }

 export enum StringFrequencyType {
    DAYS = 'DAYS',
    MONTHS = 'MONTHS',
    YEARS = 'YEARS',
    HOUR = 'HOUR'
 }

export enum Aggregator {
    AVG = 1,
    COUNT = 2,
    MIN = 3,
    MAX = 4,
    SUM = 5
 }

 export enum SchedulerRepetition {
    NEVER = 1,
    DAILY = 2,
    WEEKLY = 3,
    YEARLY = 4
 }

 export enum RangeChartView {
    TABLE = 'table',
    CHART = 'chart' 
 }

 export enum WorkflowRectTypes {
    PROCESS = 1,
    NOTIFICATION = 2,
    CONDITION = 3,
    START = 4,
    END = 5
 }

 export enum PlatformComponents {
    DASHBOARD = 'dashboard',
    PROCESS_MANAGER = "process_manager",
    USER = 'user',
    PROCESS = 'process',
    MODEL3D = '3d_model',
    QR_CODE = 'qr_code',
    SCHEDULER = 'scheduler',
    HISTORY = 'history'
 }

 export enum NotificationTypes {
     EMAIL = 1,
     SMS = 2,
     APP = 3
 }

 export enum AssignmentTypes {
     GROUP = 1,
     USER = 2
 }

 export enum NewWorkflow {
     url = 'newWorkflow'
 }

 export enum ProcessComparison {
     EQUAL = '=',
     BIGGER_THAN = '>',
     EQUAL_OR_BIGGER = '>=',
     MINOR = '<',
     MINOR_OR_EQUAL = '<=',
     DIFFERS = '<>'
 }

 export enum OperationType {
    OR = 'or',
    AND = 'and'
 }